class ProductStickyCart {
  constructor() {
    this.mainBuyButton = document.querySelector('.product-form__submit');
    this.stickyBar = document.querySelector('.product-sticky-cart');
    this.stickyScrollButton = document.querySelector('.product-sticky-cart__button');

    if (!this.mainBuyButton || !this.stickyBar || !this.stickyScrollButton) return;

    this.initObserver();
    this.initEvents();
  }

  initObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Calculate the current viewport bounding box positions
        const isPastButton = window.scrollY > (entry.boundingClientRect.top + window.scrollY);

        // STRIKT RULE: Only show the sticky bar if the main button is off-screen AND we are below it.
        if (!entry.isIntersecting && isPastButton) {
          this.stickyBar.classList.add('is-visible');
        } else {
          this.stickyBar.classList.remove('is-visible');
        }
      });
    }, { 
      threshold: 0, 
      rootMargin: '0px 0px 0px 0px' 
    });

    observer.observe(this.mainBuyButton);
  }

  initEvents() {
    this.stickyScrollButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.mainBuyButton.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    });
  }
}

// Instantiate the tracker once the DOM finishes parsing
document.addEventListener('DOMContentLoaded', () => {
  new ProductStickyCart();
});